/**
 * EditTextSection Component
 * UI for editing text content in an existing text document (edit mode)
 * Pure presentational component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TextField } from '@mui/material';
import { EditTextSectionProps } from '../types';

export const EditTextSection: React.FC<EditTextSectionProps> = ({
  content,
  onChange
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 600 }}>
        {t('documents.dialog.documentContent')}
      </Typography>
      <TextField
        margin="normal"
        required
        fullWidth
        label={t('documents.dialog.content')}
        name="content"
        value={content}
        onChange={onChange}
        multiline
        rows={12}
        helperText={t('documents.dialog.contentHelp')}
        variant="outlined"
      />
    </>
  );
};
